import { render, staticRenderFns } from "./other-income-ledger.vue?vue&type=template&id=aacd41fe"
import script from "./other-income-ledger.js?vue&type=script&lang=js&external"
export * from "./other-income-ledger.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports